import {
    SET_HEADER_ANALYSE_RISQUES,
    SET_CURRENT_ANALYSE_RISQUES_RISKS,
    SET_SPP_COMPANIES,
    SET_RA_COMPANIES,
    IS_LOADING,
    SET_REDIRECT_URL,
    SET_EDITION_STATE,
    SET_ANALYSES_RISQUES,
    GET_RISK_TYPES,
    GET_INSTRUCTION_TYPES,
    GET_PPE_LIST,
    GET_ACCREDITATIONS_TYPES,
    SET_ICP_PARTICIPANTS,
    SET_MODULE,
    SET_PARTIAL_SPP,
    SET_NB_AR_TO_RESEND,
    SET_NB_SPP_TO_RESEND,
    SET_VALIDATION_IN_PROGRESS_FILTER,
    SET_FILTERED_ANALYSES_RISQUES,
    SET_NB_COMPANIES_DISPLAY,
} from "./analyseRisquesConstants";
import moment from "moment";
import { throwErrorMessage } from "../../lib/error_helper";
import { fetchWithTimeout } from "../../lib/fetch_wrapper";
import { isPPS } from "./analyseRisquesStatusActions";
import db from "../../db";
import { clone, tryParseInt } from "../../utils";

function fillPartialSppAction(partialSpp) {
    return {
        type: SET_PARTIAL_SPP,
        partialSpp,
    };
}

function setHeaderAction(header) {
    return {
        type: SET_HEADER_ANALYSE_RISQUES,
        header: header,
    };
}

function setModuleAction(moduleSpp) {
    return {
        type: SET_MODULE,
        moduleSpp: moduleSpp,
    };
}

function setCurrentRisksAction(risks) {
    return {
        type: SET_CURRENT_ANALYSE_RISQUES_RISKS,
        currentRisks: risks,
    };
}

function setSppCompaniesAction(companies) {
    return {
        type: SET_SPP_COMPANIES,
        companies: companies,
    };
}

function setRaCompaniesAction(companies) {
    return {
        type: SET_RA_COMPANIES,
        companies: companies,
    };
}

function setParticipantsAction(participants) {
    return {
        type: SET_ICP_PARTICIPANTS,
        participants: participants,
    };
}

function setAnalysesRisquesAction(analysesRisques) {
    return {
        type: SET_ANALYSES_RISQUES,
        analysesRisques: analysesRisques,
    };
}

function setFilteredAnalysesRisquesAction(filteredAr) {
    return {
        type: SET_FILTERED_ANALYSES_RISQUES,
        filteredAnalysesRisques: filteredAr,
    };
}

function setNbArToResendAction(nb) {
    return {
        type: SET_NB_AR_TO_RESEND,
        nbArToResend: nb,
    };
}

function setNbSppToResendAction(nb) {
    return {
        type: SET_NB_SPP_TO_RESEND,
        nbSppToResend: nb,
    };
}

function setOnlyValidationInProgressCheckedAction(value) {
    return {
        type: SET_VALIDATION_IN_PROGRESS_FILTER,
        onlyValidationInProgressChecked: value,
    };
}

function getRiskTypesAction(riskTypes) {
    return {
        type: GET_RISK_TYPES,
        riskTypes: riskTypes,
    };
}

function getPpeListAction(ppeList) {
    return {
        type: GET_PPE_LIST,
        ppeList: ppeList,
    };
}

function getWorkingAccreditationsAction(accreditations) {
    return {
        type: GET_ACCREDITATIONS_TYPES,
        accreditations: accreditations,
    };
}

function getInstructionsAction(instructionTypes) {
    return {
        type: GET_INSTRUCTION_TYPES,
        instructionTypes: instructionTypes,
    };
}

export function setRedirectUrlAction(url) {
    return {
        type: SET_REDIRECT_URL,
        url: url,
    };
}

export function analyseRisquesIsLoading(value) {
    return {
        type: IS_LOADING,
        info: "AR/PPS",
        isLoading: value,
    };
}

export function setEditionStateAction(state) {
    return {
        type: SET_EDITION_STATE,
        state,
    };
}

export function setNbCompaniesDisplay(nbCompaniesDisplay) {
    return {
        type: SET_NB_COMPANIES_DISPLAY,
        nbCompaniesDisplay: nbCompaniesDisplay,
    };
}

export function fillPartialSpp(partialSpp) {
    return (dispatch) => {
        dispatch(fillPartialSppAction(partialSpp));
    };
}

export function setModule(moduleSpp) {
    return (dispatch) => {
        dispatch(setModuleAction(moduleSpp));
    };
}

export function getDefaultRisk(id, riskTypeId, participants, connectedEmployee) {
    return {
        id: id,
        riskTypeId: riskTypeId ? riskTypeId : "",
        image: undefined,
        solutions: [getDefaultSolution(connectedEmployee, participants)],
    };
}

export function getDefaultParticipants() {
    return [
        getDefaultParticipant(1, true, "", false),
        getDefaultParticipant(2, false, process.env.INSTANCE_NAME, false, true),
        getDefaultParticipant(3),
        getDefaultParticipant(4),
        getDefaultParticipant(5),
        getDefaultParticipant(6),
        getDefaultParticipant(7),
        getDefaultParticipant(8),
        getDefaultParticipant(9),
    ];
}

export function getDefaultParticipant(id, customer = false, name = "", canChangeName = true, mainCompany = false) {
    let types = getParticipantTypes();
    let defaultTypeId;

    if (id !== 0 && types.length > 0) defaultTypeId = types[id - 1].id;
    else defaultTypeId = types[0].id;

    return {
        id: id,
        typeId: defaultTypeId,
        supplier: null,
        works: "",
        numberOfParticipants: 0,
        mainCompany,
        numberOfInterimaires: 0,
        tabletSupplierRef: name,
        canChangeName: canChangeName,
        customer: customer,
    };
}

export function getParticipantType(code) {
    return getParticipantTypes().find((pt) => pt.id === code);
}

export function getParticipantTypes() {
    return [
        {
            id: "eu",
            name: "EU",
        },
        {
            id: "ee1",
            name: "EE1",
        },
        {
            id: "ee2",
            name: "EE2",
        },
        {
            id: "ee3",
            name: "EE3",
        },
        {
            id: "ee4",
            name: "EE4",
        },
        {
            id: "ee5",
            name: "EE5",
        },
        {
            id: "ee6",
            name: "EE6",
        },
        {
            id: "ee7",
            name: "EE7",
        },
        {
            id: "ee8",
            name: "EE8",
        },
    ];
}

export function getDefaultHeader(spp, ppeList) {
    let status = "ra_draft";

    if (spp) status = "spp_draft";

    let now = new Date();

    return {
        ot: null,
        numOt: "",
        affair: null,
        affairInput: "",
        customerRefTablet: "",
        checkBeforeSubmit: false,
        customer_contact_tablet: "",
        company: "",
        status: status,
        creationDate: null,

        //ICP
        jointInspectionDate: moment(),
        communicatedInformation: "",
        icpParticipants: "",

        //Works nature
        emergencyNumber: "",
        natureAndLocation: "",
        startDate: moment(),
        expectedEndDate: moment(),
        localeAgency: "",
        morningScheduleStart: new Date(now.setHours(8, 0, 0)),
        morningScheduleEnd: new Date(now.setHours(12, 30, 0)),
        afternoonScheduleStart: new Date(now.setHours(13, 30, 0)),
        afternoonScheduleEnd: new Date(now.setHours(18, 0, 0)),
        duration: 0,
        plannedOperationsDetails: "",

        //Security
        ppe: ppeList
            ? ppeList
                  .filter((ppe) => ppe.default)
                  .map((e) => {
                      return { value: e.id, label: e.name };
                  })
            : [],
        necessaryEquipments: [],
        availableEquipments: [],
        specificsEquipments: "",
        instructions: [],
        additionnalInformations: "",
        place: "",
        equipment: "",
        accreditations: [],
        additionnalInformationAccreditations: "",
    };
}

export function getDefaultSolution(connectedEmployee, participants) {
    let concernedCompanies = [];
    let instructionTypeId = null;
    let commentRequired = false;

    getDefaultCompanies(connectedEmployee).forEach((c) => {
        let concerned = false;
        let participant = participants.find((x) => x.typeId === c.id);
        if (participant && participant.tabletSupplierRef !== "") {
            concerned = true;
        }
        concernedCompanies.push({
            company: c,
            concerned: c.id === "eu" || c.id === "ee1" || concerned,
        });
    });

    return {
        id: 0,
        solutionTypeId: instructionTypeId,
        commentRequired: commentRequired,
        concernedCompanies: concernedCompanies,
        deleted: false,
        comment: null,
    };
}

export function getDefaultCompany(id, customer = false, name = "") {
    return {
        id: id,
        name: name,
        customer: customer,
        mainCompany: false,
        signature: null,
        email: "",
        type: customer ? getParticipantTypes()[0] : getParticipantType(id),
        concerned: customer,
    };
}

export function getDefaultCompanies(connectedEmployee) {
    return [
        getDefaultCompany("eu", true),
        getMainCompany(connectedEmployee),
        getDefaultCompany("ee2", false),
        getDefaultCompany("ee3", false),
        getDefaultCompany("ee4", false),
        getDefaultCompany("ee5", false),
        getDefaultCompany("ee6", false),
        getDefaultCompany("ee7", false),
        getDefaultCompany("ee8", false),
    ];
}

export function getMainCompany(connectedEmployee) {
    return {
        id: "ee1",
        name: connectedEmployee.name,
        customer: false,
        mainCompany: true,
        signature: null,
        email: connectedEmployee.email,
        type: getParticipantTypes()[1],
        concerned: true,
    };
}

export function initSppStatus(header) {
    return (dispatch) => {
        header.status = "spp_draft";
        dispatch(setHeader(header));
    };
}

export function toShortName(company) {
    return company.id;
}

export function redirect(url) {
    return (dispatch) => {
        dispatch(setRedirectUrlAction(url));
    };
}

export function getMaxRiskId(risks) {
    var maxid = 0;

    risks.forEach(function (obj) {
        if (obj.id > maxid) maxid = obj.id;
    });

    return maxid + 1;
}

export function getMaxParticipantId(participants) {
    var maxid = 0;

    participants.forEach(function (obj) {
        if (obj.id > maxid) maxid = obj.id;
    });

    return maxid;
}

export function addCreationSolutionIfNeeded(currentSolutions, instructionTypes, connectedEmployee) {
    let indexOfCreationLine = currentSolutions.find(function (element) {
        return element.id === 0;
    });

    if (!indexOfCreationLine) currentSolutions.push(getDefaultSolution(connectedEmployee, instructionTypes));

    return currentSolutions;
}

export function fillIdOfSolutionAndAddCreationSolution(solutions, instructionTypes, connectedEmployee) {
    let solution = solutions.find(function (element) {
        return element.id === 0;
    });
    solution.id = getMaxSolutionId(solutions) + 1;
    solutions = addCreationSolutionIfNeeded(solutions, instructionTypes, connectedEmployee);
    return solutions;
}

export function getMaxSolutionId(solutions) {
    let maxId = 0;

    solutions.forEach(function (obj) {
        if (obj.id > maxId) maxId = obj.id;
    });

    return maxId;
}

export function setHeader(header) {
    return (dispatch) => {
        dispatch(setHeaderAction(header));
    };
}

export function setRiskType(
    risk,
    newRiskTypeId,
    riskTypes,
    header,
    oldRisks,
    allPpe,
    connectedUser,
    participants,
    nbCompaniesDisplay
) {
    return (dispatch) => {
        let risks = clone(oldRisks);
        risk.solutions = updateSolutions(
            risk.solutions,
            newRiskTypeId,
            risk.riskTypeId,
            riskTypes,
            connectedUser,
            participants
        );

        // MàJ des participants concernés par le risque
        let newNbCompaniesDisplay = { ...nbCompaniesDisplay };
        newNbCompaniesDisplay[risk.id] = {};
        risk.solutions.forEach((solution) => {
            let concernedCompanies = solution.concernedCompanies;
            var index = concernedCompanies.length - 1;
            for (var i = index; i >= 0; i--) {
                if (concernedCompanies[i].concerned) {
                    index = i;
                    break;
                }
            }
            if (index < 1) {
                index = 1;
            }
            if (!(solution.id in newNbCompaniesDisplay[risk.id])) {
                newNbCompaniesDisplay[risk.id][solution.id] = index + 1;
            }
        });
        dispatch(setNbCompaniesDisplay(newNbCompaniesDisplay));

        risk = risks.find((r) => r.id === risk.id);
        risk.riskTypeId = newRiskTypeId;
        dispatch(setRisks(risks, riskTypes, header, oldRisks, allPpe));
    };
}

export function updateSolutions(solutions, newRiskTypeId, oldRiskTypeId, riskTypes, connectedUser, participants) {
    if (oldRiskTypeId) {
        let oldRisk = riskTypes.find((rt) => rt.id === oldRiskTypeId);
        let solutionTypeIdsToDelete = oldRisk.default_measure_ids.map((m) => m.id);

        solutionTypeIdsToDelete.forEach((solutionTypeIdToDelete) => {
            let solutionsToDelete = solutions.filter((s) => s.solutionTypeId === solutionTypeIdToDelete);

            solutionsToDelete.forEach((std) => {
                let indexToDelete = solutions.indexOf(std);
                solutions[indexToDelete].deleted = true;
            });
        });
    }

    if (newRiskTypeId) {
        let newRisk = riskTypes.find((rt) => rt.id === newRiskTypeId);
        let solutionTypeToAdd = newRisk.default_measure_ids;
        solutionTypeToAdd.forEach((solutionTypeToAdd) => {
            let currentSolution = getDefaultSolution(connectedUser, participants);
            currentSolution.id = getMaxSolutionId(solutions) + 1;
            currentSolution.solutionTypeId = solutionTypeToAdd.id;
            solutions.push(currentSolution);
        });
    }

    return solutions.sort(sortBySolutionId);
}

export function setRisks(risks, riskTypes, header, oldRisks, allPpe, allMeasures) {
    return (dispatch) => {
        if (riskTypes && header && oldRisks) {
            dispatch(updatePPEFromRisks(risks, riskTypes, header, oldRisks, allPpe, allMeasures));
        }

        dispatch(setCurrentRisksAction(risks));
    };
}

export function updatePPEFromRisks(risks, riskTypes, header, oldRisks, allPpe) {
    return (dispatch) => {
        let ppeIdsToAdd = getPPEIdsFromRisks(risks, riskTypes);
        let ppeIdsToDelete = [];

        let oldRiskTypeIds = oldRisks.map((or) => or.riskTypeId);
        let newRiskTypeIds = risks.map((r) => r.riskTypeId);
        let riskTypeIdsToDelete = oldRiskTypeIds.filter(
            (oldRiskTypeId) => oldRiskTypeId && !newRiskTypeIds.some((newRiskTypeId) => newRiskTypeId === oldRiskTypeId)
        );

        riskTypeIdsToDelete.forEach((riskTypeIdToDelete) => {
            let riskType = riskTypes.find((rt) => rt.id === riskTypeIdToDelete);
            if (riskType) ppeIdsToDelete = ppeIdsToDelete.concat(riskType.epi_ids.map((epi) => epi.id));
        });

        header.ppe = getNewPpeList(header, ppeIdsToAdd, ppeIdsToDelete, allPpe);
        dispatch(setHeader(header));
    };
}

export function getNewPpeList(header, ppeIdsToAdd, ppeIdsToDelete, allPpe) {
    let ppeList = clone(header.ppe);

    ppeIdsToAdd.forEach((ppeIdToAdd) => {
        if (!header.ppe.some((ppe) => ppe.value === ppeIdToAdd)) {
            let ppeToAdd = allPpe.find((ppe) => ppe.id === ppeIdToAdd);
            ppeList.push({ value: ppeToAdd.id, label: ppeToAdd.name });
        }
    });

    ppeList = ppeList.filter((ppe) => !ppeIdsToDelete.some((ppeIdToDelete) => ppeIdToDelete === ppe.value));
    return ppeList;
}

export function getPPEIdsFromRisks(risks, riskTypes) {
    let ppeList = [];

    risks.forEach((r) => {
        let riskType = riskTypes.find((rt) => rt.id === r.riskTypeId);

        if (riskType) ppeList = ppeList.concat(riskType.epi_ids.map((epi) => epi.id));
    });

    return ppeList;
}

export function setSolutions(
    currentSolutions,
    currentRiskId,
    currentRisks,
    raCompanies,
    sppCompanies,
    participants,
    moduleSpp
) {
    return (dispatch) => {
        currentRisks.find((r) => r.id === currentRiskId).solutions = currentSolutions.filter((s) => !s.deleted);
        dispatch(setRisks(currentRisks));

        if (raCompanies) dispatch(updateSignatories(currentRisks, raCompanies, sppCompanies, participants, moduleSpp));
    };
}

function updateSignatories(currentRisks, raCompanies, sppCompanies, participants, moduleSpp) {
    return (dispatch) => {
        raCompanies.forEach((c) => (c.concerned = false));
        sppCompanies.forEach((c) => (c.concerned = false));
        participants.forEach((p) => (p.concerned = false));

        for (let i = 0; i < raCompanies.length; i++) {
            let currentParticipant = participants.find((p) => p.typeId === raCompanies[i].id);
            let participantsNb = tryParseInt(currentParticipant.numberOfParticipants.toString());
            let participantFilled = currentParticipant.works || participantsNb || currentParticipant.supplier;

            if (
                currentParticipant &&
                (participantFilled || currentParticipant.customer || currentParticipant.mainCompany)
            ) {
                sppCompanies[i].concerned = true;
                raCompanies[i].concerned = true;
                participants[i].concerned = true;
            }

            currentRisks.forEach((r) => {
                r.solutions.forEach((s) => {
                    let currentCompany = s.concernedCompanies.find((cc) => cc.company.id === raCompanies[i].id);
                    let companyConcerned =
                        currentCompany.concerned || raCompanies[i].customer || raCompanies[i].mainCompany;

                    if (currentCompany && companyConcerned) {
                        raCompanies[i].concerned = true;
                        participants[i].concerned = true;
                        sppCompanies[i].concerned = true;
                    }
                });
            });
        }

        if (!moduleSpp) dispatch(setRaCompanies(raCompanies));

        dispatch(setSppCompanies(sppCompanies));
        dispatch(setParticipantsAction(participants));
    };
}

export function setRaCompanies(companies) {
    return (dispatch) => {
        dispatch(setRaCompaniesAction(companies));
    };
}

export function setSppCompanies(companies) {
    return (dispatch) => {
        dispatch(setSppCompaniesAction(companies));
    };
}

export function setParticipants(currentRisks, raCompanies, sppCompanies, participants, moduleSpp) {
    return (dispatch) => {
        dispatch(updateSignatories(currentRisks, raCompanies, sppCompanies, participants, moduleSpp));
        //dispatch(setParticipantsAction(participants));
    };
}

export function selectAnalyseRisques(analyseRisques) {
    return (dispatch) => {
        dispatch(setHeader(analyseRisques));
        dispatch(setCurrentRisksAction(analyseRisques.risks));
        dispatch(setRaCompanies(analyseRisques.raCompanies));
        dispatch(setSppCompanies(analyseRisques.sppCompanies));

        let moduleSpp = isPPS(analyseRisques.status);
        dispatch(
            setParticipants(
                analyseRisques.risks,
                analyseRisques.raCompanies,
                analyseRisques.sppCompanies,
                analyseRisques.participants,
                moduleSpp
            )
        );
    };
}

export function redirectToLastVisualizedArOrPps(pps) {
    return async (dispatch) => {
        dispatch(setEditionState(false, true));
        let lastVisualizedArOrPps = await getLastVisualizedArOrPps(pps);

        if (!lastVisualizedArOrPps) return;

        dispatch(selectAnalyseRisques(lastVisualizedArOrPps));

        let editUrl;

        if (pps) editUrl = "/pps/editPps";
        else editUrl = "/analyseRisques/editAnalyseRisques";

        dispatch(setModule(pps));

        dispatch(redirect(editUrl));
    };
}

export function redirectToArOrPps(id) {
    return async (dispatch) => {
        dispatch(setEditionState(false, true));
        let arOrPps = await getArOrPps(id);

        if (!arOrPps) return;

        dispatch(selectAnalyseRisques(arOrPps));

        let editUrl;
        let isSpp = isPPS(arOrPps.status);
        if (isSpp) editUrl = "/pps/editPps";
        else editUrl = "/analyseRisques/editAnalyseRisques";

        dispatch(setModule(isSpp));
        dispatch(redirect(editUrl));
    };
}

export async function getLastVisualizedArOrPps(moduleSpp = false) {
    return await db.Pps.filter((arOrPps) => {
        return isPPS(arOrPps.status) === moduleSpp;
    })
        .toArray()
        .then((risksAndPreventionsList) => {
            return risksAndPreventionsList.sort(orderByVisualizationDate)[0];
        });
}

async function getArOrPps(id) {
    return await db.Pps.toArray().then((risksAndPreventionsList) => {
        let arOrPps;
        let filteredList = risksAndPreventionsList.filter((currentArOrPps) => currentArOrPps.id === id);

        if (filteredList.length > 0) arOrPps = filteredList[0];

        return arOrPps;
    });
}

export function resetAnalyseRisquesSelection(connectedEmployee, ppeList, riskTypes, header) {
    let defaultRiskTypes = riskTypes.filter((x) => x.add_by_default);
    let defaultRisks = defaultRiskTypes.map((dr, idx) => {
        let defaultRisk = getDefaultRisk(idx + 1, dr.id, [], connectedEmployee);
        defaultRisk.solutions = updateSolutions(defaultRisk.solutions, dr.id, 0, riskTypes, connectedEmployee, []);
        return defaultRisk;
    });

    return (dispatch) => {
        dispatch(setHeader(getDefaultHeader(false, ppeList)));
        dispatch(setRisks(defaultRisks, riskTypes, header, [], ppeList));
        dispatch(setRaCompanies(getDefaultCompanies(connectedEmployee)));
        dispatch(setSppCompanies(getDefaultCompanies(connectedEmployee)));
        dispatch(setParticipantsAction(getDefaultParticipants()));
    };
}

export function setEditionState(creationMode, updateMode) {
    return (dispatch) => {
        dispatch(
            setEditionStateAction({
                creationMode,
                updateMode,
            })
        );
    };
}

export function orderByCreationDate(left, right) {
    let rightCreationDate = moment(new Date(right.creationDate));
    let leftCreationDate = moment(new Date(left.creationDate));

    return rightCreationDate.format("X") - leftCreationDate.format("X");
}

export function orderByVisualizationDate(left, right) {
    let rightVisualizationDate = moment(new Date(right.visualizationDate));
    let leftVisualizationDate = moment(new Date(left.visualizationDate));

    return rightVisualizationDate.format("X") - leftVisualizationDate.format("X");
}

export function fillAnalysesRisques(analysesRisquesState) {
    return (dispatch) => {
        db.Pps.toArray().then((risksAndPreventionsList) => {
            let arList = risksAndPreventionsList.sort(orderByCreationDate).filter((ar) => {
                return !isPPS(ar.status);
            });

            dispatch(setAnalysesRisquesAction(arList));
            const newAnalysesRisquesState = analysesRisquesState;
            newAnalysesRisquesState.analysesRisques = arList;
            dispatch(filterAnalysesRisques(newAnalysesRisquesState));
        });
    };
}

export function fillSimplifiedPreventionPlans(analysesRisquesState) {
    return (dispatch) => {
        db.Pps.toArray().then((risksAndPreventionsList) => {
            let ppsList = risksAndPreventionsList
                .sort(function (left, right) {
                    return (
                        moment(new Date(right.creationDate)).format("X") -
                        moment(new Date(left.creationDate)).format("X")
                    );
                })
                .filter((pps) => {
                    return isPPS(pps.status);
                });

            dispatch(setAnalysesRisquesAction(ppsList));
            const newAnalysesRisquesState = analysesRisquesState;
            newAnalysesRisquesState.analysesRisques = ppsList;
            dispatch(filterAnalysesRisques(newAnalysesRisquesState));
        });
    };
}

export function getRiskTypes(onSuccess) {
    return (dispatch) => {
        const headers = new Headers({ "Content-Type": "application/json" });
        fetchWithTimeout("/api/v2/spp/get_all_risks", {
            method: "GET",
            headers: headers,
        })
            .then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response;
            })
            .then((response) => response.json())
            .then((riskTypes) => {
                dispatch(getRiskTypesAction(riskTypes));
                if (typeof onSuccess === "function") onSuccess(riskTypes);
            })
            .catch((err) => {
                console.error("Erreur : analyseRisquesActions - getRiskTypes", err);
                dispatch(
                    throwErrorMessage({
                        errorObject: err,
                        title: "Erreur",
                        message: "Erreur lors de la récupération des types de risque !",
                    })
                );
            });
    };
}

export function getPpeList(onSuccess) {
    return (dispatch) => {
        const headers = new Headers({ "Content-Type": "application/json" });
        fetchWithTimeout("/api/v1/spp/get_ppe_list", {
            method: "GET",
            headers: headers,
        })
            .then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response;
            })
            .then((response) => response.json())
            .then((ppeList) => {
                dispatch(
                    getPpeListAction(
                        ppeList.sort((a, b) => {
                            return ("" + a.name).localeCompare(b.name);
                        })
                    )
                );

                if (typeof onSuccess === "function") onSuccess(ppeList);
            })
            .catch((err) => {
                console.error("Erreur : analyseRisquesActions - getPpeList", err);
                dispatch(
                    throwErrorMessage({
                        errorObject: err,
                        title: "Erreur",
                        message: "Erreur lors de la récupération des types d'EPI !",
                    })
                );
            });
    };
}

export function getWorkingAccreditations() {
    return (dispatch) => {
        const headers = new Headers({ "Content-Type": "application/json" });
        fetchWithTimeout("/api/v1/spp/get_working_accreditations", {
            method: "GET",
            headers: headers,
        })
            .then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response;
            })
            .then((response) => response.json())
            .then((accreditations) => {
                dispatch(getWorkingAccreditationsAction(accreditations));
            })
            .catch((err) => {
                console.error("Erreur : analyseRisquesActions - getWorkingAccreditations", err);
                dispatch(
                    throwErrorMessage({
                        errorObject: err,
                        title: "Erreur",
                        message: "Erreur lors de la récupération des types d'habilitations !",
                    })
                );
            });
    };
}

export function getInstructionTypes() {
    return (dispatch) => {
        const headers = new Headers({ "Content-Type": "application/json" });
        fetchWithTimeout("/api/v1/spp/get_all_instruction_types", {
            method: "GET",
            headers: headers,
        })
            .then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response;
            })
            .then((response) => response.json())
            .then((instructionTypes) => {
                instructionTypes.forEach((type) => (type.commentRequired = type.comment_required));
                dispatch(getInstructionsAction(instructionTypes));
            })
            .catch((err) => {
                console.error("Erreur : analyseRisquesActions - getInstructions", err);
                dispatch(
                    throwErrorMessage({
                        errorObject: err,
                        title: "Erreur",
                        message: "Erreur lors de la récupération des types de mesure !",
                    })
                );
            });
    };
}

export function getAffair(code, header, userId) {
    return (dispatch) => {
        const minLengthOfAffairCode = 4;
        header.numOt = "";
        header.ot = null;
        header.affair = null;

        if (code.length < minLengthOfAffairCode) {
            header.affairInput = code;
            dispatch(setHeader(header)); //On veut quand même que la saisie soit enregistrée
            return;
        }

        const headers = new Headers({ "Content-Type": "application/json" });
        fetchWithTimeout("/api/v1/affair/get_affair/" + userId + "/" + code, {
            method: "GET",
            headers: headers,
        })
            .then((response) => {
                if (!response.ok) throw Error(response.statusText);

                return response;
            })
            .then((response) => response.json())
            .then((affair) => {
                if (!affair.affairNotFound) {
                    header.affair = affair;
                    header.localeAgency = affair.company_id[0];
                } else header.affair = null;

                dispatch(setHeader(header));
            })
            .catch((err) => {
                console.error("Erreur : analyseRisquesActions - getAffair", err);
                dispatch(
                    throwErrorMessage({
                        errorObject: err,
                        title: "Erreur",
                        message: "Erreur lors de la récupération de l'affaire !",
                    })
                );
                dispatch(setHeader(header)); //On veut quand même que la saisie soit enregistrée
            });
    };
}

export function getWorkOrder(code, header, userId) {
    return (dispatch) => {
        const minLengthOfOTCode = 8;
        header.affairInput = "";
        header.affair = null;

        if (code.length < minLengthOfOTCode) {
            header.numOt = code;
            header.ot = null;
            header.affair = null;
            header.affairInput = "";
            dispatch(setHeader(header)); //On veut quand même que la saisie soit enregistrée
            return;
        }

        const headers = new Headers({ "Content-Type": "application/json" });
        fetchWithTimeout("/api/v1/work_order/get_work_order/" + userId + "/" + code, {
            method: "GET",
            headers: headers,
        })
            .then((response) => {
                if (!response.ok) throw Error(response.statusText);

                return response;
            })
            .then((response) => response.json())
            .then((ot) => {
                if (ot.otNotFound) {
                    dispatch(
                        throwErrorMessage({
                            title: "OT introuvable",
                            message:
                                "Cet ordre de travail est introuvable ou vous n'avez pas les droits nécessaires pour l'utiliser",
                        })
                    );
                }

                if (!ot.otNotFound && ot.affair) {
                    header.ot = ot;
                    header.affair = ot.affair;
                    header.affairInput = ot.affair.code;

                    if (ot.affair.company_id) header.localeAgency = ot.affair.company_id[0];
                } else {
                    header.ot = null;
                    header.affair = null;
                    header.affairInput = "";
                }

                dispatch(setHeader(header));
            })
            .catch((err) => {
                console.error("Erreur : analyseRisquesActions - getWorkOrder", err);
                dispatch(
                    throwErrorMessage({
                        errorObject: err,
                        title: "Erreur",
                        message: "Erreur lors de la récupération de l'ordre de travail !",
                    })
                );
                dispatch(setHeader(header)); //On veut quand même que la saisie soit enregistrée
            });
    };
}

export function cleanOldAnalyseRisques(moduleSpp, analysesRisquesState) {
    return (dispatch) => {
        db.transaction("rw?", db.Pps, () => {
            let ppsListToDelete = [];
            db.Pps.toArray()
                .then((ppsList) => {
                    let twoMonthsAgo = moment().add(-2, "M");

                    ppsList.forEach((pps) => {
                        if (pps.status === "spp_closed") ppsListToDelete.push(pps);

                        let ppsDate = moment(new Date(pps.startDate));
                        if (ppsDate < twoMonthsAgo && pps.status !== "spp_draft" && pps.status !== "ra_draft") {
                            ppsListToDelete.push(pps);
                        }
                    });

                    return ppsListToDelete;
                })
                .then((ppsListToDelete) => {
                    ppsListToDelete.forEach((pps) => {
                        db.Pps.delete(pps.mobileId);
                    });

                    if (!moduleSpp) dispatch(fillAnalysesRisques(analysesRisquesState));
                    else dispatch(fillSimplifiedPreventionPlans(analysesRisquesState));
                })
                .catch((err) => {
                    console.error("Erreur : analyseRisquesActions - cleanOldAnalyseRisques");
                    let message = "Une erreur s'est produite lors de la purge des anciennes analyses de risques";

                    if (moduleSpp)
                        message =
                            "Une erreur s'est produite lors de la purge des anciens plans de prévention simplifié";

                    dispatch(
                        throwErrorMessage({
                            errorObject: err,
                            title: "Erreur",
                            message: message,
                        })
                    );
                });
        }).catch((err) => {
            console.error("Erreur : analyseRisquesActions - cleanOldAnalyseRisques");
            let message = "Une erreur s'est produite lors de la purge des anciennes analyses de risques";

            if (moduleSpp)
                message = "Une erreur s'est produite lors de la purge des anciens plans de prévention simplifié";

            dispatch(
                throwErrorMessage({
                    errorObject: err,
                    title: "Erreur",
                    message: message,
                })
            );
        });
    };
}

export function buildOpenErpCode(openErpId) {
    let code;

    const ppsPrefix = "PPS-";
    const codeLength = 9;
    code = ppsPrefix;

    let numberOfZeroToComplete = codeLength - code.length - openErpId.toString().length;

    for (var i = 0; i < numberOfZeroToComplete; i++) {
        code = code.concat("0");
    }

    code = code.concat(openErpId);

    return code;
}

export function redirectToListPage(moduleSpp, analysesRisquesState) {
    return (dispatch) => {
        if (moduleSpp) {
            dispatch(fillSimplifiedPreventionPlans(analysesRisquesState));
            dispatch(redirect("/pps"));
        } else {
            dispatch(fillAnalysesRisques(analysesRisquesState));
            dispatch(redirect("/analyseRisques"));
        }
    };
}

export function actualizeNumberOfArOrPpsToResend(moduleSpp) {
    return (dispatch) => {
        db.Pps.filter((arOrPps) => {
            return arOrPps.validationInProgress && isPPS(arOrPps.status) === moduleSpp;
        })
            .toArray()
            .then((sppList) => {
                if (moduleSpp) dispatch(setNbSppToResendAction(sppList.length));
                else dispatch(setNbArToResendAction(sppList.length));
            });
    };
}

export function filterAnalysesRisques(analysesRisquesState) {
    return (dispatch) => {
        let filteredAnalysesRisques = analysesRisquesState.analysesRisques.filter((ar) =>
            analysesRisquesState.onlyValidationInProgressChecked ? ar.validationInProgress : true
        );
        dispatch(setFilteredAnalysesRisquesAction(filteredAnalysesRisques));
    };
}

export function setOnlyValidationInProgressChecked(value, analysesRisquesState) {
    return (dispatch) => {
        dispatch(setOnlyValidationInProgressCheckedAction(value));
        let newAnalysesRisquesState = analysesRisquesState;
        newAnalysesRisquesState.onlyValidationInProgressChecked = value;
        dispatch(filterAnalysesRisques(newAnalysesRisquesState));
    };
}

export function sortBySolutionId(a, b) {
    if (a.id === 0) return 1;

    if (b.id === 0) return -1;

    return a - b;
}
